module.exports = __webpack_public_path__ + "static/media/test_specialFormatting_multi.e827adae.csv";